import React, { useState } from 'react';
import CenteredModal from '../../../common/CenteredModal';
import { PlusIcon } from '@heroicons/react/24/outline';

export function ColorQuickCreate({ quickCreateData, setQuickCreateData, handleQuickCreate }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setQuickCreateData(prev => ({
      ...prev,
      color: {
        ...prev.color,
        [name]: value
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!quickCreateData.color.name_de || !quickCreateData.color.name_en) return;
    
    setLoading(true);
    try {
      // Map the data to match backend expectations
      const colorData = {
        name_de: quickCreateData.color.name_de,
        name_en: quickCreateData.color.name_en,
        color_code: quickCreateData.color.color_code
      };
      console.log('ColorQuickCreate - colorData:', colorData);
      
      // Only use handleQuickCreate to create the color
      await handleQuickCreate('colors', colorData);
      
      // Reset the form
      setQuickCreateData(prev => ({
        ...prev,
        color: { 
          name_de: '', 
          name_en: '', 
          color_code: '#000000' 
        }
      }));
      
      setOpen(false);
    } catch (error) {
      console.error('Error creating color:', error);
      alert(`Error creating color: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="ml-1 px-2 py-1 rounded bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-200 hover:bg-emerald-200 dark:hover:bg-emerald-800 transition"
        onClick={() => setOpen(true)}
        title="Neue Farbe anlegen"
      >
        <PlusIcon className="w-5 h-5" />
      </button>
      <CenteredModal open={open} onClose={() => setOpen(false)} title="Neue Farbe anlegen">
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-semibold mb-1 text-gray-700 dark:text-gray-200">Name (DE)</label>
            <input
              type="text"
              name="name_de"
              value={quickCreateData.color.name_de || ''}
              onChange={handleChange}
              className="w-full rounded border border-gray-300 dark:border-zinc-600 px-3 py-2 bg-white dark:bg-zinc-900 text-gray-900 dark:text-white"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-semibold mb-1 text-gray-700 dark:text-gray-200">Name (EN)</label>
            <input
              type="text"
              name="name_en"
              value={quickCreateData.color.name_en || ''}
              onChange={handleChange}
              className="w-full rounded border border-gray-300 dark:border-zinc-600 px-3 py-2 bg-white dark:bg-zinc-900 text-gray-900 dark:text-white"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-semibold mb-1 text-gray-700 dark:text-gray-200">Farbwert (HEX)</label>
            <div className="flex items-center gap-2">
              <input
                type="color"
                name="color_code"
                value={quickCreateData.color.color_code || '#000000'}
                onChange={handleChange}
                className="w-12 h-8 p-0 border-2 border-gray-300 dark:border-zinc-600 rounded cursor-pointer"
                required
              />
              <span className="text-sm text-gray-700 dark:text-gray-200">{quickCreateData.color.color_code || '#000000'}</span>
            </div>
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <button 
              type="button" 
              onClick={() => setOpen(false)} 
              className="px-4 py-2 rounded bg-gray-200 dark:bg-zinc-700 text-gray-800 dark:text-gray-200"
              disabled={loading}
            >
              Abbrechen
            </button>
            <button 
              type="button"
              onClick={handleSubmit}
              className="px-4 py-2 rounded bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? 'Wird gespeichert...' : 'Anlegen'}
            </button>
          </div>
        </div>
      </CenteredModal>
    </>
  );
} 